import { ErrorBoundary } from 'components/common/error-boundary';
import { GameInProgress } from 'components/main/section-router/game-in-progress';
import { NotFound } from 'components/main/section-router/not-found';
import { SectionGate } from 'components/main/section-router/section-gate';
import { Unavailable } from 'components/main/section-router/unavailable';
import { AdminPortal } from 'components/sections/admin-portal';
import { AnalyticsRouter } from 'components/sections/analytics/router';
import { FeatureDemo } from 'components/sections/feature-demo';
import { HitterLibraryRouter } from 'components/sections/hitter-library/router';
import { PitchesRouter } from 'components/sections/pitches/router';
import { VideoLibrary } from 'components/sections/video-library';
import { SectionName } from 'enums/route.enums';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { paths } from 'routes/paths';
import { useAuthStore } from 'stores/use-auth-store';

const HOME = <PitchesRouter />;

export const SectionRouter = () => {
  // check TOS 1x on mount
  useEffect(() => {
    useAuthStore.getState().checkTerms();
  }, []);

  return (
    <ErrorBoundary identifier="SectionRouter">
      <Routes>
        <Route
          // PitchesRouter to handle subsection
          path={`${paths.pitches.root}/*`}
          element={<PitchesRouter />}
        />

        <Route
          path={`${paths.hitterLibrary.root}/*`}
          element={
            <SectionGate section={SectionName.HitterLibrary}>
              <HitterLibraryRouter />
            </SectionGate>
          }
        />

        <Route
          path={paths.videoLibrary}
          element={
            <SectionGate section={SectionName.VideoLibrary}>
              <VideoLibrary identifier="VideosLibrary" />
            </SectionGate>
          }
        />

        <Route
          // AnalyticsRouter to handle subsection
          path={`${paths.analytics.root}/*`}
          element={
            <SectionGate section={SectionName.Analytics}>
              <AnalyticsRouter />
            </SectionGate>
          }
        />

        <Route
          // AdminPortal to handle subsection
          path={`${paths.admin.root}/*`}
          element={
            <SectionGate section={SectionName.AdminPortal}>
              <AdminPortal />
            </SectionGate>
          }
        />

        <Route
          path={paths.featureDemo}
          element={
            <SectionGate section={SectionName.FeatureDemo}>
              <FeatureDemo />
            </SectionGate>
          }
        />

        <Route path={paths.unavailable} element={<Unavailable />} />

        <Route path={paths.gameInProgress} element={<GameInProgress />} />

        <Route path={paths.notFound} element={<NotFound />} />

        <Route path="/*" element={HOME} />
      </Routes>
    </ErrorBoundary>
  );
};
